import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { isNil } from 'lodash'
import { type BadgeReward } from 'src/types/api'

const path = '/le-connect/badgerewards/{id}'
const method = 'get' as const

export const useGetLocationBadgeById = (
  badgeRewardId: number | undefined
): UseQueryResult<BadgeReward> => {
  const get = useTypedApiClient({ path, method })

  return useQuery({
    queryKey: [path, badgeRewardId],
    queryFn: async () => {
      if (isNil(badgeRewardId)) {
        throw new Error('badgeRewardId is required')
      }

      const { data } = await get({ id: badgeRewardId })
      return data
    },
    enabled: !isNil(badgeRewardId),
  })
}
